import React from "react";
import {
  form,
  Form as AppForm,
  TextArea
} from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { onSuccess } from "LIB/submission";
import { connect } from "react-redux";
import * as actions from "MODULES/RMAsAndWarranties/actions";
import { Button } from "react-bootstrap";

export function Form(props) {
  const { close, handleSubmit, reset } = props;
  const onCancel = () => {
    close();
    reset();
  };
  const submit = onSuccess(handleSubmit, onCancel, props);

  return (
    <AppForm {...props} onSubmit={submit}>
      <AppForm.Body>
        <div className="row">
          <div className="col-md-12">
            <Field
              name="rma_discrepancy"
              component={TextArea}
              label="Discrepancy Information"
            />
          </div>
        </div>
      </AppForm.Body>
      <AppForm.Footer>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={() => submit()} className="btn btn-success">
          Download Vendor RMA
        </Button>
      </AppForm.Footer>
    </AppForm>
  );
}

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => dispatch(actions.download(data, ownProps.url))
}))(
  form({
    form: "rmaDiscrepancy"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Actions/Form.jsx